<nav class="lesson-navigation" aria-label="Lesson navigation">
  <button
    type="button"
    class="nav-button nav-previous"
    [disabled]="!hasPrevious"
    (click)="onPreviousClick()"
    aria-label="Previous lesson">
    <svg class="button-icon" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path d="M16.6663 10H3.33301M3.33301 10L8.33301 15M3.33301 10L8.33301 5" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <span class="button-text">Previous</span>
  </button>

  <button
    type="button"
    class="nav-button nav-continue"
    [disabled]="isContinueDisabled"
    (click)="onContinueClick()"
    [attr.aria-label]="continueButtonText + (hasQuiz && isLastLesson ? '' : ' lesson')">
    <span class="button-text">{{ continueButtonText }}</span>
    <svg class="button-icon" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path d="M4.16699 10H15.8337M15.8337 10L10.0003 4.16669M15.8337 10L10.0003 15.8334" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </button>
</nav>
